var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "likert_edit",
    },
    [
      _c(
        "div",
        {
          ref: "autofocus",
          staticClass: "formpart",
          attrs: {
            tabindex: "0",
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$gettext("Einleitungstext")) +
              "\n        "
          ),
          _c("studip-wysiwyg", {
            model: {
              value: _vm.val_clone.description,
              callback: function callback($$v) {
                _vm.$set(_vm.val_clone, "description", $$v)
              },
              expression: "val_clone.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "sr-only",
          attrs: {
            "aria-live": "assertive",
          },
        },
        [_vm._v(_vm._s(_vm.assistiveLive))]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "default nohover",
        },
        [
          _c("thead", [
            _c(
              "tr",
              [
                _c("th", {
                  staticClass: "dragcolumn",
                }),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$gettext("Aussagen")))]),
                _vm._v(" "),
                _vm._l(_vm.val_clone.options, function (option, index) {
                  return _c(
                    "th",
                    {
                      key: index,
                    },
                    [_vm._v(_vm._s(option))]
                  )
                }),
                _vm._v(" "),
                _c("th", {
                  staticClass: "actions",
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "draggable",
            {
              staticClass: "statements",
              attrs: {
                handle: ".dragarea",
                tag: "tbody",
              },
              model: {
                value: _vm.val_clone.statements,
                callback: function callback($$v) {
                  _vm.$set(_vm.val_clone, "statements", $$v)
                },
                expression: "val_clone.statements",
              },
            },
            _vm._l(_vm.val_clone.statements, function (statement, index) {
              return _c(
                "tr",
                {
                  key: index,
                },
                [
                  _c(
                    "td",
                    {
                      staticClass: "dragcolumn",
                    },
                    [
                      _c(
                        "a",
                        {
                          ref: "draghandle_" + index,
                          refInFor: true,
                          staticClass: "dragarea",
                          attrs: {
                            tabindex: "0",
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext(
                                "Sortierelement für Aussage %{statement}. Drücken Sie die Tasten Pfeil-nach-oben oder Pfeil-nach-unten, um dieses Element in der Liste zu verschieben."
                              ),
                              {
                                statement: statement,
                              }
                            ),
                          },
                          on: {
                            keydown: function keydown($event) {
                              return _vm.keyHandler($event, index)
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "drag-handle",
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.val_clone.statements[index],
                          expression: "val_clone.statements[index]",
                        },
                      ],
                      ref: "statement_" + index,
                      refInFor: true,
                      attrs: {
                        type: "text",
                        placeholder: _vm.$gettext("Aussage"),
                      },
                      domProps: {
                        value: _vm.val_clone.statements[index],
                      },
                      on: {
                        paste: function paste(ev) {
                          return _vm.onPaste(ev, index)
                        },
                        input: function input($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.val_clone.statements,
                            index,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.val_clone.options, function (option, index2) {
                    return _c(
                      "td",
                      {
                        key: index2,
                      },
                      [
                        _c("input", {
                          attrs: {
                            type: "radio",
                            disabled: "",
                            title: option,
                          },
                        }),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "actions",
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          name: "delete",
                          shape: "trash",
                          size: 20,
                          title: _vm.$gettext("Aussage löschen"),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.deleteStatement(index)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("tfoot", [
            _c("tr", [
              _c(
                "td",
                {
                  attrs: {
                    colspan: _vm.val_clone.options.length + 3,
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      name: "add",
                      shape: "add",
                      size: 20,
                      title: _vm.$gettext("Aussage hinzufügen"),
                    },
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        return _vm.addStatement()
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.val_clone.mandatory,
              expression: "val_clone.mandatory",
              modifiers: {
                number: true,
              },
            },
          ],
          attrs: {
            type: "checkbox",
            "true-value": "1",
            "false-value": "0",
          },
          domProps: {
            checked: Array.isArray(_vm.val_clone.mandatory)
              ? _vm._i(_vm.val_clone.mandatory, null) > -1
              : _vm._q(_vm.val_clone.mandatory, "1"),
          },
          on: {
            change: function change($event) {
              var $$a = _vm.val_clone.mandatory,
                $$el = $event.target,
                $$c = $$el.checked ? "1" : "0"
              if (Array.isArray($$a)) {
                var $$v = _vm._n(null),
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(_vm.val_clone, "mandatory", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.val_clone,
                      "mandatory",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.val_clone, "mandatory", $$c)
              }
            },
          },
        }),
        _vm._v("\n        " + _vm._s(_vm.$gettext("Pflichtfrage")) + "\n    "),
      ]),
      _vm._v(" "),
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.val_clone.randomize,
              expression: "val_clone.randomize",
              modifiers: {
                number: true,
              },
            },
          ],
          attrs: {
            type: "checkbox",
            "true-value": "1",
            "false-value": "0",
          },
          domProps: {
            checked: Array.isArray(_vm.val_clone.randomize)
              ? _vm._i(_vm.val_clone.randomize, null) > -1
              : _vm._q(_vm.val_clone.randomize, "1"),
          },
          on: {
            change: function change($event) {
              var $$a = _vm.val_clone.randomize,
                $$el = $event.target,
                $$c = $$el.checked ? "1" : "0"
              if (Array.isArray($$a)) {
                var $$v = _vm._n(null),
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(_vm.val_clone, "randomize", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.val_clone,
                      "randomize",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.val_clone, "randomize", $$c)
              }
            },
          },
        }),
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$gettext("Antworten den Teilnehmenden zufällig präsentieren")
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", [
            _vm._v(_vm._s(_vm.$gettext("Antwortmöglichkeiten konfigurieren"))),
          ]),
          _vm._v(" "),
          _c("input-array", {
            model: {
              value: _vm.val_clone.options,
              callback: function callback($$v) {
                _vm.$set(_vm.val_clone, "options", $$v)
              },
              expression: "val_clone.options",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }